import React, { Component } from "react";

import capitalize from "../../capitalize";
import { put, del } from "../../api";

import Modal from "../Modal/Modal";
import Form from "../Form/Form";

import "./CategoryDetails.css";

class CategoryDetails extends Component {
  state = {
    name: this.props.category.name,
    searchWords: this.props.category.searchWords.join("\n"),
    inactive: this.props.category.inactive
  };

  onSave = async () => {
    try {
      const { name = "", searchWords = "", inactive = false } = this.state;
      console.log("save", name, inactive);
      const category = await put("/categories/" + this.props.category.id, {
        name,
        searchWords: JSON.stringify(searchWords.split("\n")),
        inactive
      });
      this.props.onEdited(category);
    } catch (err) {
      alert(err.message);
    }
  };

  onDelete = async () => {
    const { id, name } = this.props.category;
    if (window.confirm("Delete category " + name + "?")) {
      try {
        await del("/categories/" + id);
        this.props.onDeleted(this.props.category);
      } catch (err) {
        alert(err.message);
      }
    }
  };

  render() {
    const { name = "", searchWords = "", inactive = false } = this.state;

    return (
      <Modal
        narrow
        extraClassName="CategoryDetails"
        onCancel={this.props.onClose}
        onSave={this.onSave}
        saveText="Save"
        title="Edit category"
      >
        <Form>
          <div>
            <label>Name</label>
            <input
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              type="text"
              placeholder="Enter name"
              value={capitalize(name)}
              onChange={e => this.setState({ name: e.target.value })}
            />
          </div>
          <div>
            <label>Search words</label>
            <textarea
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              placeholder="One word per line"
              value={searchWords}
              onChange={e => this.setState({ searchWords: e.target.value })}
            ></textarea>
          </div>
          <div>
            <label>Inactive</label>
            <input
              type="checkbox"
              checked={inactive}
              onChange={e => this.setState({ inactive: e.target.checked })}
            />
          </div>
          <div>
            <button
              className="deleteButton"
              type="button"
              onClick={this.onDelete}
            >
              Delete
            </button>
          </div>
        </Form>
      </Modal>
    );
  }
}

export default CategoryDetails;



// WEBPACK FOOTER //
// ./src/components/Categories/CategoryDetails.js